export default __webpack_public_path__ + "static/ultraball-939ed10cf5072cb57898aa5c87862c80.png";